<script lang="ts">
    import {getLocalization} from '../../../svelte/context';

    const localize = getLocalization();
</script>

<template>
    <p class="kp-everbis-advertisement">
        {localize(/* @kp-localization index.everbis.AdvertisementMsg */ 'index.everbis.AdvertisementMsg')}
        <a href="https://everbis.cz" target="_blank" rel="noreferrer" class="btn btn-success">
            {localize(/* @kp-localization index.everbis.CreateFreeLibrary */ 'index.everbis.CreateFreeLibrary')}
        </a>
    </p>
</template>

<style lang="less">
    p {
        font-size: 14px;
        color: #fff;
    }
</style>